import chatModule from './chat.js';
import relatedPosts from './related-posts.js';
import popupBanner from './banner.js';
import searchModal from './search-modal.js';

const footer = {
  $footer: document.getElementById('main_footer'),
  $ppcFooter: document.getElementById('ppc_footer'),
  $modal: document.getElementById('modal'),
  init() {
    if (this.$footer || this.$ppcFooter) {
      console.log('Footer init');
      this.setUpAccolades();
    }
    relatedPosts.init();
    chatModule.init();
    popupBanner.init();
    searchModal.init();
    this.setUpListeners();
  },

  setUpListeners() {
    if (this.$modal) {
      PubSub.subscribe('modal.open', this.openModal.bind(this));
      PubSub.subscribe('modal.close', this.closeModal.bind(this));
      this.$modal
        .addEventListener('click', ({target}) => {
          if (target.classList.contains('modal')
          || target.closest('.close_btn')) {
            this.closeModal();
          }
        });
    }

    if (this.$ppcFooter) {
      this.$ppcFooter
        .querySelector('.title_wrapper > .btn')
        .addEventListener('click', (ev) => {
          const $form = document.querySelector('section.contact_us_block');

          if ($form) {
            ev.preventDefault();
            $form.scrollIntoView({behavior: 'smooth', block: 'start'});
          }
        });
    }
  },

  setUpAccolades() {
    if (window.innerWidth <= 768) {
      PubSub.publish('embla.init', {
        name: 'footer-carousel',
        $els: document.querySelectorAll('#main_footer .accolades'),
        options: {
          loop: false
        },
        plugins: [
          // EmblaCarouselAutoScroll({
          //   speed: 0.3,
          //   playOnInit: false,
          //   startDelay: 0
          // })
        ]
      });
    }
  },

  openModal(ev, $content) {
    this.$modal
      .querySelector('.content_wrapper > .content')
      .append($content);

    this.$modal
      .classList
      .add('active');

    if ($content && $content.dataset.youtubeId) {
      new Vlitejs($content, {
        options: {
          controls: true,
          autoplay: true,
          muted: false
        },
        provider: 'youtube',
      });
    } else if ($content && $content.classList.contains('tjh_video')) {
      new Vlitejs($content, {
        options: {
          controls: true,
          autoplay: true,
          muted: false
        }
      });
    }
  },

  closeModal() {
    this.$modal
      .querySelector('.content_wrapper > .content')
      .innerHTML = '';

    this.$modal
      .classList
      .remove('active');
  },

  destroy() {
    relatedPosts.destroy();
  }
};

export default footer;
